/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateOrderItem = /* GraphQL */ `
  subscription OnCreateOrderItem(
    $filter: ModelSubscriptionOrderItemFilterInput
  ) {
    onCreateOrderItem(filter: $filter) {
      id
      customerNumber
      email
      printManufacturer
      notificationAt
      billingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      shippingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      status
      files {
        key
        name
      }
      furtherInfo
      furtherInfoFlowingMotifs
      furtherInfoQualityCheck
      positions {
        articleNumber
        articleName
        quantity
        productGroup
        widthByMm
        heightByMm
        White
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
      }
      chooseUpload
      deliveryDate
      uploadedDate
      createdAt
      language
      lastOpened
      manufacturerNote
      internalNote
      shippingMethod
      zollanmeldung
      activityLogs {
        items {
          id
          operation
          field
          value
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
          updatedBy
          createdAt
          updatedAt
          typename
          orderItemActivityLogsId
        }
        nextToken
      }
      lastUpdatedBy
      typename
      updatedAt
    }
  }
`;
export const onUpdateOrderItem = /* GraphQL */ `
  subscription OnUpdateOrderItem(
    $filter: ModelSubscriptionOrderItemFilterInput
  ) {
    onUpdateOrderItem(filter: $filter) {
      id
      customerNumber
      email
      printManufacturer
      notificationAt
      billingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      shippingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      status
      files {
        key
        name
      }
      furtherInfo
      furtherInfoFlowingMotifs
      furtherInfoQualityCheck
      positions {
        articleNumber
        articleName
        quantity
        productGroup
        widthByMm
        heightByMm
        White
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
      }
      chooseUpload
      deliveryDate
      uploadedDate
      createdAt
      language
      lastOpened
      manufacturerNote
      internalNote
      shippingMethod
      zollanmeldung
      activityLogs {
        items {
          id
          operation
          field
          value
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
          updatedBy
          createdAt
          updatedAt
          typename
          orderItemActivityLogsId
        }
        nextToken
      }
      lastUpdatedBy
      typename
      updatedAt
    }
  }
`;
export const onDeleteOrderItem = /* GraphQL */ `
  subscription OnDeleteOrderItem(
    $filter: ModelSubscriptionOrderItemFilterInput
  ) {
    onDeleteOrderItem(filter: $filter) {
      id
      customerNumber
      email
      printManufacturer
      notificationAt
      billingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      shippingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      status
      files {
        key
        name
      }
      furtherInfo
      furtherInfoFlowingMotifs
      furtherInfoQualityCheck
      positions {
        articleNumber
        articleName
        quantity
        productGroup
        widthByMm
        heightByMm
        White
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
      }
      chooseUpload
      deliveryDate
      uploadedDate
      createdAt
      language
      lastOpened
      manufacturerNote
      internalNote
      shippingMethod
      zollanmeldung
      activityLogs {
        items {
          id
          operation
          field
          value
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
          updatedBy
          createdAt
          updatedAt
          typename
          orderItemActivityLogsId
        }
        nextToken
      }
      lastUpdatedBy
      typename
      updatedAt
    }
  }
`;
export const onCreateManufacturer = /* GraphQL */ `
  subscription OnCreateManufacturer(
    $filter: ModelSubscriptionManufacturerFilterInput
  ) {
    onCreateManufacturer(filter: $filter) {
      id
      name
      email
      createdAt
      typename
      updatedAt
    }
  }
`;
export const onUpdateManufacturer = /* GraphQL */ `
  subscription OnUpdateManufacturer(
    $filter: ModelSubscriptionManufacturerFilterInput
  ) {
    onUpdateManufacturer(filter: $filter) {
      id
      name
      email
      createdAt
      typename
      updatedAt
    }
  }
`;
export const onDeleteManufacturer = /* GraphQL */ `
  subscription OnDeleteManufacturer(
    $filter: ModelSubscriptionManufacturerFilterInput
  ) {
    onDeleteManufacturer(filter: $filter) {
      id
      name
      email
      createdAt
      typename
      updatedAt
    }
  }
`;
export const onCreateActivityLog = /* GraphQL */ `
  subscription OnCreateActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onCreateActivityLog(filter: $filter) {
      id
      operation
      field
      value
      positionImage {
        key
        pdfKey
        quantity
        thumbnail
        filledPositionArticleNumber
        size
        comment
        approvalStatus
        acceptedDescription
        rejectedReason
        rejectedDescription
        fullName
        files {
          key
          name
        }
      }
      updatedBy
      createdAt
      updatedAt
      typename
      orderItemActivityLogsId
    }
  }
`;
export const onUpdateActivityLog = /* GraphQL */ `
  subscription OnUpdateActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onUpdateActivityLog(filter: $filter) {
      id
      operation
      field
      value
      positionImage {
        key
        pdfKey
        quantity
        thumbnail
        filledPositionArticleNumber
        size
        comment
        approvalStatus
        acceptedDescription
        rejectedReason
        rejectedDescription
        fullName
        files {
          key
          name
        }
      }
      updatedBy
      createdAt
      updatedAt
      typename
      orderItemActivityLogsId
    }
  }
`;
export const onDeleteActivityLog = /* GraphQL */ `
  subscription OnDeleteActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onDeleteActivityLog(filter: $filter) {
      id
      operation
      field
      value
      positionImage {
        key
        pdfKey
        quantity
        thumbnail
        filledPositionArticleNumber
        size
        comment
        approvalStatus
        acceptedDescription
        rejectedReason
        rejectedDescription
        fullName
        files {
          key
          name
        }
      }
      updatedBy
      createdAt
      updatedAt
      typename
      orderItemActivityLogsId
    }
  }
`;
